















import { Component } from 'vue-property-decorator';
import MixinPage from '@/plugins/podolib/services/helper/mixins/page';

@Component({
  metaInfo() {
    return {
      title: this.$options.filters!.capitalize(this.$t('commons.errors.not-found')),
      titleTemplate: '%s | Podosmart',
    };
  },
  mounted() {
    this.$pdc.bus!.emitDebug('app:ready');
  },
})
export default class PageNotFound extends MixinPage {}
